import { types, flow, castToSnapshot } from 'mobx-state-tree';
import { pick } from 'lodash';

import { navigate, makeRequest, url, errorResponse } from 'js/services/Network';
import analytics from 'js/services/Analytics';
import CreditCard from 'js/stores/types/CreditCard';
import OrderSummary from 'js/stores/types/OrderSummary';

export default types
  .model('ManageOrderPage', {
    error: types.maybeNull(types.string),
    isSubmitting: false,
    modalIsVisible: false,
    contactModalIsVisible: false,
    ipAddressesMatchModalIsVisible: false,
    //credit_card: types.optional(CreditCard, {}),
    item_alias: '',
    alias: '',
    order_summary: types.maybe(OrderSummary),
    phone_number: '',
    full_name: '',
    shipping: '',
    uid: '',
    is_expired: false,
    is_declined: false,
    offer_failed: false,
    ip_addresses_check: false,
    ip_addresses_matched: false
  })
  .views(self => ({
    get canSubmit() {
      return !!self.phone_number && self.full_name.length && !self.ip_addresses_matched;//self.credit_card.isFilledIn &&
    },
    get isDisabled() {
      return self.is_expired || self.is_declined || self.offer_failed;
    },
  }))
  .actions(self => ({
    load: flow(function* load() {
      const response = yield makeRequest('manage-order-data', self);

      if(!response.data.credit_card){
        response.data.credit_card = {};
      }
      if(!response.data.credit_card.address){
        response.data.credit_card.address = {};
      }

      self.credit_card = response.data.credit_card;
      self.item_alias = response.data.item_alias;
      self.alias = response.data.alias;
      self.order_summary = response.data.order_summary;
      self.phone_number = response.data.phone_number;
      self.full_name = response.data.full_name;
      self.shipping = response.data.shipping;
      self.uid = response.data.uid;
      self.is_expired = response.data.is_expired;
      self.is_declined = response.data.is_declined;
      self.offer_failed = response.data.offer_failed;

      return response;
    }),

    submit: flow(function* submit() {
      let response;
      if (!self.isSubmitting) {
        self.isSubmitting = true;
        self.error = null;

        try {
          if(!self.ip_addresses_check && window.app.env === 'production'){
              const ipAddressesSameResponse = yield makeRequest('ip-match-check', self);
              if(ipAddressesSameResponse.data){
                //analytics.track('IP addresses are same');
                self.ip_addresses_check = true;
                self.ipAddressesMatchModalIsVisible = true;
                self.ip_addresses_matched = true;
                return false;
              }
          }

          response = yield makeRequest('confirm-order', self, pick(self, ['credit_card', 'phone_number', 'full_name']));
          console.log('confirm-order api:', response );

          analytics.track('CTA_SP_confirm_order', {
            'Order Title': self.order_summary?.title,
            'Order Price': self.order_summary?.price,
            'Buyer': self.order_summary?.buyer,
            'Seller': self.full_name,
            'Payment Method': self.order_summary?.payment_method,
            'Pickup': self.order_summary?.pickup,
            'Delivery': self.order_summary?.delivery,
            'Event Initiated by': 'seller'
          });

          navigate(url('status-page', self.order_summary));
        } catch (error) {
          console.log('ERROR', error.response.data);
          self.error = errorResponse(error);
        }

        self.isSubmitting = false;
      }
      return response;
    }),

    creditCardSaved(creditCard) {
      if (!self.isDisabled) {
        self.credit_card.setCreditCard(castToSnapshot(creditCard));
        self.modalIsVisible = false;
      }
    },
    editPaymentMethod() {
      if (!self.isDisabled) {
        //analytics.page('AO_viewed enter cc modal');
        self.modalIsVisible = true;
      }
      return self;
    },
    editContact() {
      if (!self.isDisabled) {
        self.contactModalIsVisible = true;
      }
      return self;
    },
    closeModal() {
      self.modalIsVisible = false;
      self.contactModalIsVisible = false;
      self.ipAddressesMatchModalIsVisible = false;
      self.isSubmitting = false;
      return self;
    },
    closeIpAddressesMatchModal(){
      this.closeModal();
      self.isSubmitting = false;
      return self;
    },
    setContactData(contactData) {
      self.full_name = contactData.full_name;
      self.phone_number = contactData.phone_number;
      self.contactModalIsVisible = false;
      return self;
    },
  }));
